const removeDecimal = (decimal = "") => (decimal) && decimal.replace(".", "");

export default removeDecimal;
